<template>
  <div class="container pt-3 pb-1 step-1">
    <div class="row">
      <div class="col-12">
        <p class="lora h3">Wybór dodatkowych ofert</p>
        <!-- dodatków? -->
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 order-1 order-md-0 h-100">
        <div class="md-left">
          <div class="white-panel">
            <!-- <ul>
                  <li>nocleg w komfortowym pokoju</li>
                  <li>Internet bezprzewodowy na terenie całego obiektu</li>
                </ul>-->

            <!-- tabela z dodatkami -->
            <div v-for="(occupation, index) in schema.occupancy.$items" :key="'ad_room_' + index" class="table-dodatki">
              <div>
                Pokój {{ index + 1 }}: {{ occupation.$item.room.name.$value }}

                <span>dorosłych: {{ occupation.$item.numberOfAdults.$value }}</span>
                <span v-if="occupation.$item.numberOfChildren3.$value"
                  >, dzieci do lat 3: {{ occupation.$item.numberOfChildren3.$value }}
                </span>
                <span v-if="occupation.$item.numberOfChildren12.$value"
                  >, dzieci 4-12 lat: {{ occupation.$item.numberOfChildren12.$value }}
                </span>
              </div>

              <div
                v-for="(addition, additionIndex) in additions[index].additions"
                :key="'ad_addition_' + additionIndex"
                class="row item-row"
              >
                <div class="col-6">{{ addition.name }}</div>

                <div class="col-3 text-right"><template v-if="addition.price || addition.additionPrice">{{ formatPrice(addition.price || addition.additionPrice) }} zł / {{ paymentType(addition.paymentType) }}</template></div>
                
                <div class="col-3 text-right">
                  <button
                    v-if="!addition.checked"
                    class="btn btn-secondary btn-sm"
                    @click="addAddition(occupation.$item, addition)"
                  >
                    DODAJ
                    <span>+</span>
                  </button>

                  <button v-else class="btn btn-secondary btn-sm" @click="removeAddition(occupation.$item, addition)">
                    USUŃ
                    <span>-</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 order-0 order-md-1 h-100">
        <div class="md-right">
          <SmallSummary :schema="schema" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallSummary from './SmallSummary';
import {formatPrice} from '../../utils/formatPrice'

export default {
  components: { SmallSummary },
  props: {
    schema: { type: Object, required: true },
    additions: { type: Array, required: true }
  },
  methods: {
    paymentType(type) {
      switch (type) {
        case 0:
          return 'doba';
        case 1:
          return 'raz';
      }
    },
    addAddition(occupation, addition) {
      this.$set(addition, 'checked', true);
      occupation.additions.$addRow(addition);
    },
    removeAddition(occupation, addition) {
      this.$set(addition, 'checked', false);
      const indexToRemove = occupation.additions.$items.findIndex(item=>item.$item.id.$model===addition.id);
      occupation.additions.$removeRow(indexToRemove);
    },
    formatPrice
  }
};
</script>
